module.exports = __webpack_public_path__ + "static/media/arrows-long-right.0b224fb3.svg";